module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAARVBMVEUAAABmZmZmZmZoaGhmZmZtd3pmZmZmZmYAsOUAseYAseYAtOsAsOUAsOUAseYAs+gAr+UAsOVnZ2cAsOVnZ2doaGgAr+TdGLzYAAAAFnRSTlMA8H924QzUurJrPBHtw08m1Imfl2VGFZZ4vwAAAIBJREFUKM+90ssOwkAIheGjdpwLc7WW939UzTQGaNqt/5IvYUGA88shj9n7hfMe9z9CWksPkY5AK89ytECdfw0DgaWqILGqAHB+h8G69oXnDsFAFShXEAwkgciqDAGXFQwFqDLvJKCXlQYDaEFOJTCjlBpgQBK4eIbNw/nbScv2AWViD5w59qTYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/download-unselect@2x.png
// module id = mFE+
// module chunks = 4